export * from "./FlavorFinderResultCard";
